import ClickOutside from 'vue-click-outside';
import SolrService from '@/common/solr.service';

export default {
  name: 'ExhibitorSearch',
  components: {
  },
  data() {
    return {
      options: {
        isLoading: false,
      },
      pluginConfiguration: {
        limitedFairEvents: this.limitedFairEvents,
        fairGroups: this.fairGroups,
      },
      filter: {
        autocomplete: {
          isVisible: false,
          isLoading: false,
          arrowCounter: -1,
          results: [],
        },
      },
      resultObject: {
        payload: '',
        term: '',
        weight: 0
      }
    };
  },
  props: {
    lang: {
      Type: String,
      default: 'de',
    },
    listUrl: {
      type: String,
      default: '',
    },
    positionX: {
      type: String,
      default: '0',
    },
    positionY: {
      type: String,
      default: '0',
    },
    color: {
      type: String,
      default: '0',
    },
    limitedFairEvents: {
      type: String,
      default: '',
    },
    teaser: {
      type: Boolean,
      default: false,
    },
    frameworkProgram: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    filterable() {
      return true;
    },
    filterButtonTooltip() {
      if (this.filter.isFilterVisible) {
        return this.$t('filter.close');
      }
      return this.$t('filter.open');
    },
    viewSizeMode() {
      let sizeMode = -1;
      if (this.options.windowWidth <= 768) {
        sizeMode = 0; /* tiny */
      } else if (this.options.windowWidth > 768 && this.options.windowWidth <= 1024) {
        sizeMode = 1; /* small */
      } else if (this.options.windowWidth > 1024 && this.options.windowWidth <= 1280) {
        sizeMode = 2; /* medium */
      } else if (this.options.windowWidth > 1280) {
        sizeMode = 3; /* big */
      }
      return sizeMode;
    },
    amountOfResultsShown() {
      let amount = `${this.formatNumber(this.list.amount)} ${this.$t('list.results')}`;
      if (this.favourites.showFavourites && this.favourites.items.length > 0) {
        if (this.list.amount === 0) {
          amount = '';
        } else if (this.list.amount === 1) {
          amount = `${this.list.amount} ${this.$t('list.favouriteTooltip.name.singular')}`;
        } else {
          amount = `${this.formatNumber(this.list.amount)} ${this.$t('list.favouriteTooltip.name.plural')}`;
        }
      } else if (this.list.amount === 0) {
        amount = '';
      } else if (this.list.amount === 1) {
        amount = `${this.list.amount} ${this.$t('list.result')}`;
      }
      return amount;
    },
    areNoItemsLeft() {
      return this.list.displayedAmount >= this.list.amount;
    },
  },
  created() {
    this.options.windowWidth = window.innerWidth;
  },
  methods: {
    triggerAutocomplete() {
      if (this.resultObject.term.trim().length > 0) {
        SolrService.getAutocompleteSuggetions(
          this.resultObject.term.trim(),
          this.pluginConfiguration.limitedFairEvents
        ).then((response) => {
          const sliceOption = this.viewSizeMode === 0 || this.viewSizeMode === 1 ? 3 : 10;
          const autocompleteResults = response.data.suggest.av[this.resultObject.term.trim()]
            .suggestions.slice(0, sliceOption);
          autocompleteResults.sort(
            (a, b) => {
              let sorting = 0;
              if (a.term.toLowerCase() !== b.term.toLowerCase()) {
                sorting = a.term.toLowerCase() < b.term.toLowerCase() ? -1 : 1;
              }
              return sorting;
            },
          );
          this.filter.autocomplete.results = autocompleteResults;
          if (this.filter.autocomplete.results.length > 0) {
            this.filter.autocomplete.isVisible = true;
          }
        })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {

          });
      } else {
        this.filter.autocomplete.isVisible = false;
      }
    },
    applySearch() {
      this.options.isLoading = true;
      if (this.resultObject.payload === '') {
        this.resultObject.payload = '[{"type":"searchFromDifferentLocation"}]';
      }
      sessionStorage.setItem('lms_query', JSON.stringify(this.resultObject));
      window.location = this.listUrl;
    },
    clearSearch() {
      this.resultObject = {
        payload: '',
        term: '',
        weight: 0
      };
      this.applySearch();
    },
    applyFilter() {
      if (this.viewSizeMode === 0) {
        this.filter.isFilterVisible = false;
      }
      this.list.itemsPushed = [];
      if (!this.frameworkProgram) {
        this.fetchExhibitors(0, this.list.amountToLoad, false);
      } else {
        this.fetchFrameworkProgram(0, this.list.amountToLoad, false);
      }
    },
    autocompleteSearch(autocompleteItem) {
      this.resultObject = autocompleteItem;
      this.$refs.searchButton.click();
      this.closeAutocomplete();
    },
    autocompleteItemWithHighlight(item) {
      const payloads = JSON.parse(item.payload);
      let returnHtml = '';

      if (payloads[0].type === 'category') {
        returnHtml = `<span class="ed-filter__autocompleteItem--type">${this.$t('filter.category')}</span>`;
      } else if (payloads[0].type === 'traveldestination') {
        returnHtml = `<span class="ed-filter__autocompleteItem--type">${this.$t('filter.travelDestination')}</span>`;
      }
      returnHtml += '<span class="ed-filter__autocompleteItem--title">';
      returnHtml += item.term.toString().replace(new RegExp(this.resultObject.term.trim(), 'ig'), match => `<span class="ed-filter__autocompleteItemHighlight">${match} </span>`);
      returnHtml += '</span>';

      return returnHtml;
    },
    onAutocompleteArrowDown() {
      if (this.filter.autocomplete.arrowCounter
          < this.filter.autocomplete.results.length - 1
          && this.filter.autocomplete.isVisible) {
        this.filter.autocomplete.arrowCounter = this.filter.autocomplete.arrowCounter + 1;
      }
      if (this.filter.autocomplete.isVisible) {
        this.setCursorPosition();
      }
    },
    onAutocompleteArrowUp() {
      if (this.filter.autocomplete.arrowCounter > 0 && this.filter.autocomplete.isVisible) {
        this.filter.autocomplete.arrowCounter = this.filter.autocomplete.arrowCounter - 1;
      }
      if (this.filter.autocomplete.isVisible) {
        this.setCursorPosition();
      }
    },
    onAutocompleteEnter() {
      if (this.filter.autocomplete.arrowCounter !== -1) {
        this.resultObject = this
          .filter
          .autocomplete
          .results[this.filter.autocomplete.arrowCounter];
        this.closeAutocomplete();
      }
    },
    setCursorPosition() {
      const { search } = this.$refs;

      this.$nextTick(() => {
        search.focus();
        search.setSelectionRange(
          this.resultObject.term.length, this.resultObject.term.length,
        );
      });
    },
    closeAutocomplete() {
      this.filter.autocomplete.isVisible = false;
      this.filter.autocomplete.arrowCounter = -1;
    },
    isLastElement(index, field) {
      return index === field.length - 1;
    },
    formatNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    returnItemType(type) {
      switch (type) {
        case 'MkdbExhibitorIndexBundle|||Documents|||Exhibitor':
          return this.$t('list.type.exhibitor');
        case 'MkdbExhibitorIndexBundle|||Documents|||ExhibitorProduct':
          return this.$t('list.type.product');
        case 'MkdbExhibitorIndexBundle|||Documents|||ExhibitorNews':
          return this.$t('list.type.news');
        case 'MkdbExhibitorIndexBundle|||Documents|||Brand':
          return this.$t('list.type.brand');
        default:
          return '';
      }
    },
    getCategoryWithSpaces(category) {
      return category.replace(/\|/g, ' | ');
    },
  },
  directives: {
    ClickOutside,
  },
};
